import { PlatformLocation } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthenticatedUser, Club } from 'src/app/core/models';
import { ClubService, StorageService, AuthenticationService } from 'src/app/core/services';
import { ClubTranslationsService } from 'src/app/shared/translations';


/**
 * Displays the header.
 */
@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnDestroy {
  public selectedClub: Club;
  public authenticatedUser?: AuthenticatedUser;
  public currentBaseHref: any;
  public isMenuOpened: boolean = false;
  @Input() public isLoggedIn: boolean;
  @Input() public hasSelectedApp: boolean;

  constructor(
    private browserLocation: PlatformLocation,
    public router: Router,
    public storage: StorageService,
    public clubService: ClubService,
    public clubTranslations: ClubTranslationsService,
    private authenticationService: AuthenticationService
  ) {
    this.storage.castAuthenticatedUser
      .pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => user !== null ? this.authenticatedUser = user : null);

    this.storage.castSelectedClub
      .pipe(untilDestroyed(this))
      .subscribe(club => {
        if (this.selectedClub !== club) {
          this.selectedClub = club;
          if (this.selectedClub) {
            document.querySelector('body').style.cssText = `--header-color: ${this.selectedClub.primaryColor}`;
          }
        }
      });
    this.currentBaseHref = this.browserLocation.getBaseHrefFromDOM();
  }

  public ngOnDestroy(): void { }

  /**
   * Toggle the menu.
   */
  public toggleMenu(): any {
    this.isMenuOpened = !this.isMenuOpened;
  }

  /**
   * Changes the route based on what page you are on.
   */
  public changeRoute(): any {
    if (this.authenticatedUser.isAdmin || this.authenticatedUser.isCallCenterAgent || this.authenticatedUser.isCountryManager) {
      this.router.navigate(['/manage/clubs']);
    } else {
      this.router.navigate(['club', this.selectedClub.id]);
    }
  }

  /**
   * Navigates to the user profile page
   */
  public goToProfilePage(): void {
    this.router.navigate([`/user-profile/${this.authenticatedUser.id}`]);
  }

  /**
   * Logs the user out and navigates to the login page
   */
  public logout(): void {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}
